import { ACTIONS } from '../Constants';

export const expandNavigation = () => ({
    type: ACTIONS.EXPAND_NAVIGATION
});

export const collapseNavigation = () => ({
    type: ACTIONS.COLLAPSE_NAVIGATION
});

export const updatePreviousLocation = (previousLocation) => ({
    type: ACTIONS.UPDATE_PREVIOUS_LOCATION,
    previousLocation
});
